import React from "react";
import { LegalPage } from "@/components/landing/LegalPage";

export default function Terms() {
  return <LegalPage kind="terms" />;
}
